<div class="filters" [ngClass]="theme.getThemeClass()">
  <div class="sort-by-group">
    <label class="sort-by-group-label">{{ "iotModalViewDeviceName" | translate }}</label>
    <input
      type="search"
      [(ngModel)]="view.deviceFilter"
      (ngModelChange)="view.saveFilters()"
      class="form-control rounded searchInput"
      placeholder="{{ 'iotSearchPlaceHolderFilter' | translate }}"
    />
  </div>
  <div class="sort-by-group">
    <label class="sort-by-group-label">{{ "devicecreateLabelClient" | translate }}</label>
    <select class="form-control" [(ngModel)]="view.selectedClient" (ngModelChange)="view.saveFilters()">
      <option [ngValue]="''">{{ "devicecreateSelectClient" | translate }}</option>
      @for (client of view.clientOptions; track client.client_id) {
        <option [ngValue]="client.client_id">{{ client.legal_name }}</option>
      }
    </select>
  </div>
  <div class="sort-by-group">
    <label class="sort-by-group-label">{{ "deviceGroup" | translate }}</label>
    <select class="form-control" [(ngModel)]="view.filterThingGroup" (ngModelChange)="view.saveFilters()">
      @for (row of thingGroupOptions; track row.value) {
        <option [value]="row.value">{{ row.label | translate }}</option>
      }
    </select>
  </div>
  <div class="filter-actions">
    <button class="btn btn-dropdown" [ngClass]="theme.getThemeClass()" (click)="reset()">
      {{ "resetFilters" | translate }}
    </button>
    <button class="btn btn-dropdown" [ngClass]="theme.getThemeClass()" (click)="goToCreateDevice()">
      {{ "createDevice" | translate }}
    </button>
  </div>
</div>
